// Bundle parents reject parent_id. Nest keys match hybrid-cart.
function nestBundleItems(items) {
  if (!items.some((item) => item.parent_id != null)) return items
  const nestId = crypto.randomUUID()
  return items.map((item) => {
    if (item.parent_id == null) {
      return { ...item, properties: { ...(item.properties || {}), _HC_NEST_ID: nestId } }
    }
    const { parent_id, ...rest } = item
    return { ...rest, properties: { ...(rest.properties || {}), _HC_PARENT_KEY: nestId } }
  })
}

class DeviceProductForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (!this.initialized) {
      this.init()
      this.initialized = true
    }
  }

  init() {
    console.log('init')
    try {
      this.setupAddToCart()
      this.setupPriceUpdating()
    } catch (error) {
      console.error('Error initializing DeviceProductForm:', error)
    }
  }

  setupAddToCart() {
    console.log('setupAddToCart')
    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    $$addToCartButtons.forEach(($addToCartButton) =>
      $addToCartButton.addEventListener('click', () => {
        $addToCartButton.dataset.loading = null

        const addToCartPayload = this.buildAddToCartPayload()

        this.executeAddToCart(addToCartPayload, $addToCartButton)
      })
    )

    const $deviceOnlyRadio = this.querySelector('#device-only')
    if ($deviceOnlyRadio) {
      $deviceOnlyRadio.addEventListener('change', (e) => {
        if (e.target && e.target.checked) {
          document.dispatchEvent(new CustomEvent('device-form:device-only-selected'))
        }
      })
    }
    // When upgrade radio is selected, emit event to switch gallery slide
    const $upgradeRadio = this.querySelector('#product-upgrade-radio')
    if ($upgradeRadio) {
      $upgradeRadio.addEventListener('change', (e) => {
        if (e.target && e.target.checked) {
          document.dispatchEvent(new CustomEvent('device-form:upgrade-selected'))
        }
      })
    }
  }

  buildAddToCartPayload() {
    // Desired cart display order (top → bottom):
    // main → upgrade → warranty → auto-addons/GWP → selected add-ons.
    // cart/add.js prepends each line (reversing the batch), so executeAddToCart
    // reverses this array before posting.
    const parentVariantId = Number(this.getAttribute('variant-id'))
    const items = [{ quantity: 1, id: parentVariantId }]
    const backorderMessage = this.getAttribute('data-backorder-message')
    if (backorderMessage) items[0].properties = { Backorder: backorderMessage }

    const $productUpgrade = this.querySelector('[name="product-upgrade"]:checked')
    if ($productUpgrade && $productUpgrade.value != '') {
      items.push({
        quantity: 1,
        id: Number($productUpgrade.value),
        properties: { _upgrade: true },
        parent_id: parentVariantId,
      })
    }

    const $warranty = this.querySelector('[name="warranty"]:checked')
    if ($warranty && $warranty.value != '') {
      items.push({ quantity: 1, id: Number($warranty.value), parent_id: parentVariantId })
    }

    try {
      const autoAddons = JSON.parse(this.getAttribute('auto-addons') || '[]')
      if (Array.isArray(autoAddons)) {
        autoAddons.forEach((addon) => items.push({ ...addon, parent_id: parentVariantId }))
      }
    } catch (error) {
      console.error('Error parsing autoAddons:', error)
    }

    const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
    $$addons.forEach(($addon) => {
      if ($addon.value == '') return
      items.push({
        quantity: 1,
        id: Number($addon.value),
        properties: { _addon: true },
        parent_id: parentVariantId,
      })
    })

    return { items }
  }

  executeAddToCart(addToCartPayload, $addToCartButton) {
    const warrantyIds = [40117523873827, 40117526167587, 40117524463651, 40559546564643, 40559548858403, 40559546630179]
    const hasWarranty = addToCartPayload.items.some((item) => warrantyIds.includes(item.id))

    // Shopify prepends each line in the batch, reversing display order.
    let cartItems = window.igApplyCartNesting([...addToCartPayload.items].reverse())
    if (this.dataset.bundle === 'true') cartItems = nestBundleItems(cartItems)
    const payload = { items: cartItems }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (!response.ok) {
          const error = await response.json()
          return alert(error.description || error.message)
        }

        if (hasWarranty) window.igEvents.push({ event: 'warranty-added-to-cart' })
        window.HybridCart.open()
      })
      .catch((response) => {
        console.error('Error adding to cart:', response)
      })
      .finally(() => {
        delete $addToCartButton.dataset.loading
      })
  }

  setupPriceUpdating() {
    const $productVariantsData = this.querySelector('#product-variants-data')
    if (!$productVariantsData) {
      console.error('Product variants data element not found')
      return
    }

    const productVariants = JSON.parse($productVariantsData.innerHTML)
    const automaticDiscount = Number(this.getAttribute('automatic-discount'))

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      trailingZeroDisplay: 'stripIfInteger',
    })

    const updatePrice = () => {
      // const $productUpgrade = this.querySelector('[name="product-upgrade"]:checked')
      const $warranty = this.querySelector('[name="warranty"]:checked')
      const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
      const tagsEl = this.querySelector('#product-tags')
      const isTotalValueProduct = tagsEl?.textContent?.includes('Total Value Product') || false
      const $$promoTexts = this.querySelectorAll('[data-promo-text]')
      let displayPrice = 0
      let displayCompareAtPrice = 0
      let totalPrice = 0

      // Use base product variant for device only
      let baseVariant = productVariants[0]
      const baseOriginal = parseInt(baseVariant.compare_at_price || baseVariant.price) || 0
      displayPrice = (parseInt(baseVariant.price) || 0) - automaticDiscount
      displayCompareAtPrice = baseOriginal
      totalPrice = displayPrice

      // Add warranty price to total
      if ($warranty && $warranty.value != '') {
        totalPrice += parseInt($warranty.dataset.price) || 0
      }

      // Add addon prices to total
      $$addons.forEach(($addon) => {
        if ($addon.value == '') return
        totalPrice += parseInt($addon.dataset.price) || 0
      })

      const $$price = this.querySelectorAll('[data-main-product-price]')
      const $$compareAtPrice = this.querySelectorAll('[data-main-product-compare-at-price]')

      const formattedDisplayPrice = formatter.format(displayPrice / 100)

      $$price.forEach(($price) => {
        $price.innerHTML = formattedDisplayPrice
      })

      if (displayCompareAtPrice > displayPrice) {
        const formattedCompareAtPrice = formatter.format(displayCompareAtPrice / 100)
        $$compareAtPrice.forEach(($compareAtPrice) => {
          $compareAtPrice.innerHTML = isTotalValueProduct
            ? `(Total Value ${formattedCompareAtPrice})`
            : formattedCompareAtPrice
          $compareAtPrice.classList.remove('hidden')
        })
        if ($$promoTexts.length > 0) {
          const formattedPriceDifference = formatter.format((displayCompareAtPrice - displayPrice) / 100)
          $$promoTexts.forEach(($promoText) => {
            // Only auto-recalculate promo text for automatic discount labels.
            if (!$promoText.hasAttribute('data-auto-discount-promo')) return

            let currentText = $promoText.textContent || $promoText.dataset.promoOriginalText
            if (currentText.length === 0) {
              const $promoOriginalText = document.querySelector('[data-auto-discount-promo][data-promo-original-text]')
              if ($promoOriginalText) {
                currentText = $promoOriginalText.dataset.promoOriginalText
              }
            }
            // Replace just the $ ammount
            $promoText.textContent = currentText.replace(/\$[\d,]+(?:\.\d{2})?/, formattedPriceDifference)
          })
        }
      } else {
        $$compareAtPrice.forEach(($compareAtPrice) => $compareAtPrice.classList.add('hidden'))
      }

      // Update sticky ATC mirrors outside the component
      document.querySelectorAll('[data-main-product-price]').forEach((el) => {
        el.textContent = formattedDisplayPrice
      })

      document.querySelectorAll('[data-main-product-compare-at-price]').forEach((el) => {
        if (displayCompareAtPrice > displayPrice) {
          // Preserve inner structure (sr-only/span/parentheses) by replacing only the $ amount
          const formattedCompareAt = formatter.format(displayCompareAtPrice / 100)
          el.classList.remove('hidden')
          if (/\(\s*Total Value/.test(el.innerHTML)) {
            // Replace entire parenthetical to be robust regardless of currency symbol
            el.innerHTML = el.innerHTML.replace(
              /\(\s*Total Value(?:&nbsp;|\s)*.*?\)/,
              `(Total Value&nbsp;${formattedCompareAt})`
            )
          } else if (/\$[\d,]+(?:\.\d{2})?/.test(el.innerHTML)) {
            el.innerHTML = el.innerHTML.replace(/\$[\d,]+(?:\.\d{2})?/, formattedCompareAt)
          } else {
            // Fallback
            el.textContent = formattedCompareAt
          }
        } else {
          el.classList.add('hidden')
        }
      })

      // Keep sticky promo text in sync with the main product promo text
      const mainPromo = document.querySelector('[id^="MainProduct"] [data-promo-text]')
      const mainPromoText = mainPromo?.textContent?.trim() || ''
      const mainPromoIsStatic = Boolean(mainPromoText) && mainPromo.dataset.savingsBadge === 'static'
      document
        .querySelectorAll('#pdp-sticky-nav [data-promo-text], #pdp-mobile-cta [data-promo-text]')
        .forEach((el) => {
          if (!el.dataset.fallbackPromoText) {
            el.dataset.fallbackPromoText = (el.textContent || '').trim()
          }

          el.dataset.savingsBadge = mainPromoIsStatic ? 'static' : 'amount'
          const promoText = mainPromoText || el.dataset.fallbackPromoText
          if (promoText) {
            el.textContent = promoText
            el.classList.remove('hidden')
          } else {
            el.classList.add('hidden')
          }
        })

      // Update Affirm amount
      // const $$affirmElements = this.querySelectorAll('.affirm-as-low-as')
      // $$affirmElements.forEach(($affirm) => {
      //   const affirmDiscount = parseInt($affirm.dataset.affirmDiscount) || 0
      //   $affirm.dataset.amount = displayPrice - affirmDiscount
      // })
    }

    // Ensure we're binding to the correct elements within this component
    const $$selectors = this.querySelectorAll('[name="product-upgrade"], [name="warranty"], [name="addon-product"]')

    // Add event listeners for each selector
    $$selectors.forEach(($selector) => {
      $selector.addEventListener('change', (e) => {
        updatePrice()
      })

      // Also listen for click events on radio buttons to ensure they trigger
      if ($selector.type === 'radio') {
        $selector.addEventListener('click', (e) => {
          updatePrice()
        })
      }
    })

    // Initialize price on page load
    updatePrice()
  }
}

// Ensure the custom element is defined only once
if (!customElements.get('device-product-form')) {
  customElements.define('device-product-form', DeviceProductForm)
} else {
  console.log('DeviceProductForm custom element already defined')
}